var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 15.001C27.5 21.8997 21.9 27.501 15 27.501C8.0875 27.501 2.5 21.8997 2.5 15.001C2.5 8.09973 8.0875 2.50097 15 2.50098C21.9 2.50098 27.5 8.09973 27.5 15.001ZM16.1 19.7385C16.1 20.3372 15.6 20.8385 15 20.8385C14.4 20.8385 13.9125 20.3372 13.9125 19.7385L13.9125 14.2135C13.9125 13.6122 14.4 13.126 15 13.126C15.6 13.126 16.1 13.6122 16.1 14.2135L16.1 19.7385ZM14.9875 9.14973C15.6 9.14973 16.0875 9.64973 16.0875 10.2497C16.0875 10.8497 15.6 11.3372 15 11.3372C14.3875 11.3372 13.9 10.8497 13.9 10.2497C13.9 9.64973 14.3875 9.14973 14.9875 9.14973Z",
    fill: "#FEB111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9c232a5efbbe7599763b4e5beaf39cbd.svg";
export { ForwardRef as ReactComponent };